'use strict';

// EXPORTS //

module.exports = Math.pow;
